import { Button, ButtonProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { ModalFormModel } from 'shared/lib';

export type ModalFormCancelButtonProps = ButtonProps & ElementProps<'button', keyof ButtonProps>;

export const createModalFormCancelButton = <
	TModalData,
	TFormValues extends Record<string, unknown>,
>(
	modalFormModel: ModalFormModel<TModalData, TFormValues>,
) => {
	const ModalFormCancelButton = forwardRef<HTMLButtonElement, ModalFormCancelButtonProps>(
		({ className, children, onClick, ...props }, ref) => {
			const disable = useUnit(modalFormModel.switcher.disable);

			return (
				<Button
					ref={ref}
					data-test-id='modal-form-cancel-button'
					className={clsx('modal-form-button', 'modal-form-cancel', className)}
					type='button'
					variant='outline'
					onClick={(event) => {
						event.preventDefault();
						disable();
						onClick?.(event);
					}}
					{...props}
				>
					{children}
				</Button>
			);
		},
	);

	return ModalFormCancelButton;
};
